import React from 'react';
import PropTypes from 'prop-types';

import withMessages from 'component-utilities/intl';

import { LoginFormItem } from 'v-c/Login';
import { PrimaryButton } from 'v-c/Buttons';
import {
    FormLabel,
    FormErrorText,
    FormButtons,
    InputField,
} from 'v-c/Forms';

import { stateLogic, viewLogic } from './LoginDeconstructed';

function LoginComponent(props) {
    const {
        isButtonDisabled,
        getMessage,
        usernameConfig,
        passwordConfig,
        showLoginFailedMessage,
        onSubmit,
        commonInputAttributes,
        formError,
    } = viewLogic(props);

    return (
        <div>
            <div data-login-username-password>
                <LoginFormItem name="username">
                    <FormLabel>
                        {getMessage('components.login.inputs.username')}
                    </FormLabel>
                    <InputField
                        focused
                        data-field="username"
                        value={usernameConfig.value}
                        onChange={usernameConfig.onChange}
                        {...commonInputAttributes()}
                    />
                </LoginFormItem>
                <LoginFormItem name="password">
                    <FormLabel>
                        {getMessage('components.login.inputs.password')}
                    </FormLabel>
                    <InputField
                        data-field="password"
                        type="password"
                        value={passwordConfig.value}
                        onChange={passwordConfig.onChange}
                        {...commonInputAttributes()}
                    />
                </LoginFormItem>

                {showLoginFailedMessage && (
                    <FormErrorText
                        field="login"
                        error={formError ? formError.id : null}
                        values={formError ? formError.values : null}
                    />
                )}

                <FormButtons>
                    <PrimaryButton
                        data-action="log_in"
                        disabled={isButtonDisabled}
                        onClick={onSubmit}
                    >
                        {getMessage('components.login.submit')}
                    </PrimaryButton>
                </FormButtons>
            </div>
        </div>
    );
}

LoginComponent.propTypes = {
    isButtonDisabled: PropTypes.bool.isRequired,
    getMessage: PropTypes.func.isRequired,
    usernameConfig: PropTypes.shape({
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    }).isRequired,
    passwordConfig: PropTypes.shape({
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    }).isRequired,
    commonInputAttributes: PropTypes.func.isRequired,
    showLoginFailedMessage: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    formError: PropTypes.object,
};

LoginComponent.defaultProps = {
    formError: null,
};

const Login = withMessages(stateLogic(LoginComponent));

export default Login;
